import { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
// Acromegaly React contexts
import { useMaterialUIController, setDirection } from "context";
import { useNavigate } from "react-router-dom";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { getCollaboratorWagesList } from "controllers/OrderController";
import MDTypography from "components/MDTypography";
import AdapterJalali from "@date-io/date-fns-jalali";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5, direction: "rtl" }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="صفحه اول">
        <LastPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="اخرین صفحه"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="صفحه قبلی"
      >
        <FirstPageIcon />
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};
const sorts = {};
const filters = {
  fromDate: "",
  toDate: "",
  collaborator: false,
};
const platings = ["بدون آبکاری", "طلایی", "رزگلد", "رادیوم"];

function Collaborator() {
  const [controller, dispatch] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState(filters);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [datas, setDatas] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sort, setSort] = useState(sorts);

  const navigate = useNavigate();
  let emptyRows = rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  // Avoid a layout jump when reaching the last page with empty rows.
  const getData = async (perPagex, pagex, filterx, searchx, sortx) => {
    setLoading(true);
    setDatas([]);
    filterx.collaborator = true;
    let data = await getCollaboratorWagesList(
      perPagex,
      pagex,
      searchx,
      filterx,
      sortx,
      controller.token
    );
    if (data.success) {
      let datas = data.data;
      let count = data.count;
      // filterx.collaborator = true;
      // data = await getCollaboratorWagesList(
      //   perPagex,
      //   pagex,
      //   searchx,
      //   filterx,
      //   sortx,
      //   controller.token
      // );
      // if (data.success) {
      //   alert(data.data.length);
      //   datas = [...datas, ...data.data];
      //   count += data.count;
      // }
      setDatas(datas);

      setCount(count);
      emptyRows = rowsPerPage - Math.min(rowsPerPage, datas.length - (pagex - 1) * rowsPerPage);
    } else {
      Swal.fire({
        text: data.message,
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });

      if (data.code === 401) {
        navigate("/", { replace: true });
      }
    }

    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(rowsPerPage, newPage + 1, filter, search, sort);
  };
  function numberWithCommas(x) {
    try {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch (err) {
      return 0;
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setFilter("");
    getData(parseInt(event.target.value, 10), 1, filter, search, sort);
  };

  useEffect(() => {
    setDirection(dispatch, "rtl");
    // if (!controller.authenticated) {
    //   Swal.fire({
    //     text: "برای دسترسی به این صفحه باید وارد حساب کاربری خود شوید",
    //     icon: "error",
    //     confirmButtonText: "بسیار خوب",
    //   });
    //   navigate("/", { replace: true });
    // } else {
    //   getData(10, 1, filter, "");
    // }
    getData(10, 1, filter, "", sort);
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar title=" حسابداری همکاران" />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container>
                  <Grid item xs={6} sm={6}>
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      حسابداری همکاران
                    </MDTypography>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <LoadingOverlay
                  className="overlayclass"
                  active={loading}
                  spinner
                  text="لطفا کمی صبر کنید"
                >
                  <Grid container spacing={2} pr={1} pl={1} mb={2}>
                    <Grid item lg={4} md={4} xs={12}>
                      <TextField
                        autoFocus
                        id="search"
                        fullWidth
                        variant="outlined"
                        value={search}
                        placeholder="جستجو..."
                        onChange={(event) => {
                          setSearch(event.target.value);
                          if (event.target.value === "") {
                            setPage(0);
                            getData(rowsPerPage, 1, filter, "", sort);
                          }
                        }}
                        onKeyPress={(ev) => {
                          if (ev.key === "Enter") {
                            setPage(0);
                            getData(rowsPerPage, 1, filter, search, sort);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item lg={8} md={8} xs={6}>
                      <Grid container spacing={1}>
                        <Grid item lg={3} md={3} xs={3}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="material">جنس محصول</InputLabel>
                            <Select
                              dir="rtl"
                              id="material"
                              labelId="label-material"
                              label="جنس محصول"
                              onChange={(event) => {
                                const temp = filter;
                                temp.material = event.target.value;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                            >
                              <MenuItem>
                                <em>NONE</em>
                              </MenuItem>
                              <MenuItem value="طلا">طلا</MenuItem>
                              <MenuItem value="نقره">نقره</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={3} md={3} xs={3}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="plating">آبکاری</InputLabel>
                            <Select
                              dir="rtl"
                              id="plating"
                              labelId="label-plating"
                              label="آبکاری"
                              value={filter.plating}
                              onChange={(event) => {
                                const temp = filter;
                                temp.plating = event.target.value;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                            >
                              <MenuItem>
                                <em>NONE</em>
                              </MenuItem>
                              {platings.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={3} md={3} xs={3}>
                          <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                              label="از تاریخ "
                              mask="____/__/__"
                              value={filter.fromDate}
                              onChange={(newValue) => {
                                const temp = filter;
                                temp.fromDate = newValue;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item lg={3} md={3} xs={3}>
                          <LocalizationProvider dateAdapter={AdapterJalali}>
                            <DatePicker
                              label="تا تاریخ"
                              mask="____/__/__"
                              value={filter.toDate}
                              onChange={(newValue) => {
                                const temp = filter;
                                temp.toDate = newValue;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid container px={1} mt={1} spacing={1}>
                    
                    
                    <Grid item lg={2} md={3} xs={3}>
                      {sort.collaboratorDate && sort.collaboratorDate === 1 && (
                        <Button
                          endIcon={<ArrowDownwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.collaboratorDate = undefined;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل به همکار
                        </Button>
                      )}
                      {sort.collaboratorDate && sort.collaboratorDate === -1 && (
                        <Button
                          endIcon={<ArrowUpwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.collaboratorDate = 1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل به همکار
                        </Button>
                      )}
                      {(!sort.collaboratorDate || !sort.collaboratorDate) && (
                        <Button
                          onClick={() => {
                            const temp = sort;
                            temp.collaboratorDate = -1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل به همکار
                        </Button>
                      )}
                    </Grid>

                    <Grid item lg={2} md={3} xs={3}>
                      {sort.thickness && sort.thickness === 1 && (
                        <Button
                          endIcon={<ArrowDownwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = undefined;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                      {sort.thickness && sort.thickness === -1 && (
                        <Button
                          endIcon={<ArrowUpwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = 1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                      {(!sort.thickness || !sort.thickness) && (
                        <Button
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = -1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                    </Grid>
                  </Grid> */}
                  <TableContainer component={Paper} style={{ borderWidth: 1, borderColor: "#000" }}>
                    <Table>
                      <TableBody>
                        {/* <TableRow style={{ backgroundColor: "#ccc" }}>
                          <TableCell>
                          </TableCell>
                        </TableRow> */}
                        {datas.map((row) => (
                          <TableRow
                            sx={{ "& > *": { borderBottom: "unset" } }}
                            key={row.name}
                            style={{
                              borderWidth: 1,
                              borderColor: "#000",
                              borderRadius: 5,
                            }}
                          >
                            <TableCell>
                              <div className="borderdtbltr">
                                <Grid className="tblhrader" container px={1}>
                                  <Grid
                                    container
                                    lg={12}
                                    md={12}
                                    xs={12}
                                    onClick={() => {
                                      navigate(`/collaboratordetails/${row._id}/1/${row.name}`);
                                    }}
                                  >
                                    <Grid item lg={4} md={4} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> نام نام خانوادگی: </b>
                                      {row.name}
                                    </Grid>
                                    <Grid item lg={4} md={4} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}>گالری: </b>
                                      {row.gallery}
                                    </Grid>
                                    <Grid item lg={4} md={4} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> اجرت: </b>
                                      {/* {row.collaborator !== "635682d06ceb014b0abbad6d" && */}
                                      {numberWithCommas(row.wages)}
                                      {/* }
                                      {row.collaborator == "635682d06ceb014b0abbad6d" &&
                                        numberWithCommas(row.profit)} */}
                                      <b> تومان </b>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 0 }}>
                            <TableCell />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: "همه", value: -1 }]}
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "سطر در هر صفحه",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </LoadingOverlay>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Collaborator;
